(function () {
  "use strict";

  function initRevealMt3() {
    var elementos = document.querySelectorAll(".mt3-reveal, .mt3-reveal-stagger");
    if (!elementos.length) return;
    if (!("IntersectionObserver" in window)) {
      elementos.forEach(function (el) { el.classList.add("mt3-visible"); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add("mt3-visible");
            observer.unobserve(entrada.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    elementos.forEach(function (el) { observer.observe(el); });
  }

  function initGaleriaMt3() {
    var principal = document.querySelector("[data-mt-galeria-principal] img");
    var minis = document.querySelectorAll("[data-mt-galeria-mini]");
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener("click", function () {
        var src = mini.getAttribute("data-mt-galeria-mini");
        if (src) principal.src = src;
        minis.forEach(function (m) { m.classList.remove("mt3-activa"); });
        mini.classList.add("mt3-activa");
      });
    });
  }

  function initPacksMt3() {
    var packs = document.querySelectorAll("[data-mt3-pack]");
    if (!packs.length) return;
    var form = document.querySelector("#mt-producto-form");
    if (!form) return;
    var cantidadInput = form.querySelector("[data-mt-cantidad-input]");
    var precioActual = document.querySelector("[data-mt-precio-actual]");

    function elegir(pack) {
      packs.forEach(function (p) { p.classList.remove("mt3-activa"); });
      pack.classList.add("mt3-activa");
      var radio = pack.querySelector(".mt3-pack-row__radio");
      if (radio) radio.checked = true;

      var cantidad = pack.getAttribute("data-mt3-cantidad") || "1";
      if (cantidadInput) cantidadInput.value = cantidad;

      // El precio mostrado en el propio pack ya trae el total del bundle;
      // si además existe un precio "simple" en pantalla (modo sin packs), lo sincronizamos.
      var precioMostrar = pack.getAttribute("data-mt3-precio-mostrar");
      if (precioActual && precioMostrar) precioActual.textContent = precioMostrar;
    }

    packs.forEach(function (pack) {
      pack.addEventListener("click", function () { elegir(pack); });
      var radio = pack.querySelector(".mt3-pack-row__radio");
      if (radio) radio.addEventListener("change", function () { elegir(pack); });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRevealMt3();
    initGaleriaMt3();
    initPacksMt3();
  });
})();
